import resourceReducerFactory, { resourceState } from 'reducers/resource';
import { types } from 'actions/customer-notes-actions';


export const initialState = resourceState;

export default resourceReducerFactory(initialState, types);
